import { gql } from '@apollo/client';

export const fetchInvoices = gql`
  query FetchInvoicesForTransactionAccountWithContext(
    $id: ID!
    $queryString: String
    $partnerSearchContext: PartnerSearchContext
    $pageParams: InvoicePageParams
  ) {
    transactionAccount(id: $id) {
      id
      partnerInvoices(queryString: $queryString, partnerSearchContext: $partnerSearchContext, pageParams: $pageParams) {
        totalCount
      }
    }
  }
`;

export const fetchCloudSites = gql`
  query fetchCloudSitesInPPC($searchParams: CloudSiteSearchParams) {
    partnerCloudSites(searchParams: $searchParams) {
      totalCount
    }
  }
`;

export const fetchAggregatedShipToParties = gql`
  query fetchAggregatedShipToPartiesForTransactionAccountPPC(
    $id: ID!
    $aggregatedShipToPartyOptions: AggregatedShipToPartyOptions
  ) {
    transactionAccount(id: $id) {
      id
      aggregatedShipToParty(aggregatedShipToPartyOptions: $aggregatedShipToPartyOptions) {
        totalCount
      }
    }
  }
`;

export const fetchEmails = gql`
  query fetchEmailsForTransactionAccountInPPC(
    $id: ID!
    $partnerAccountId: String!
    $searchParams: BillingAdminEmailSearchParams
  ) {
    transactionAccount(id: $id) {
      id
      emails(partnerAccountId: $partnerAccountId, searchParams: $searchParams) {
        totalCount
      }
    }
  }
`;

export const fetchEndCustomerContacts = gql`
  query fetchEndCustomerContactsInPPC($searchParams: EndCustomerContactSearchParams) {
    endCustomerContacts(searchParams: $searchParams) {
      totalCount
    }
  }
`;

export const fetchPartnerProductEntitlements = gql`
  query fetchPartnerProductEntitlements(
    $searchParams: ProductEntitlementSearchParams
    $pageParams: ProductEntitlementPageParams
  ) {
    partnerProductEntitlements(pageParams: $pageParams, searchParams: $searchParams) {
      totalCount
    }
  }
`;

export const fetchInvoiceGroupsForSearch = gql`
  query fetchInvoiceGroupsForPPCSearch(
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
    $isOrgSearchEnabled: Boolean
    $transactionAccountId: ID!
  ) {
    invoiceGroups(
      searchOptions: $searchOptions
      filterOptions: $filterOptions
      isOrgSearchEnabled: $isOrgSearchEnabled
      transactionAccountId: $transactionAccountId
    ) {
      totalCount
      nodes {
        id
      }
    }
  }
`;

export const fetchOrdersForTransactionAccountInPPC = gql`
  query fetchOrdersByTransactionAccountIdInPPC(
    $transactionAccountId: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    transactionAccount(id: $transactionAccountId) {
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
      }
    }
  }
`;

export const searchQuotesQueryForPPC = gql`
  query searchQuotesQueryForPPC($searchOptions: ConnectionSearchOptions, $filterOptions: FilterOption) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
    }
  }
`;

export const fetchBillingProfilesForPPC = gql`
  query fetchBillingProfilesForPPC($id: ID!, $searchOptions: ConnectionSearchOptions, $filterOptions: [FilterOption]) {
    transactionAccount(id: $id) {
      billingProfiles(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
      }
    }
  }
`;

export const fetchRefundsInPPC = gql`
  query fetchRefundsInPPC($searchParams: RefundSearchParams!) {
    partnerRefunds(searchParams: $searchParams) {
      results {
        id
      }
    }
  }
`;
